module.exports = __webpack_public_path__ + "img/products.dff1a947.svg";